import React from "react";
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { Tag } from "../Snippet";
import { KPILocal } from "../Chart";

const InfoHeaderBudgetAndGoal = ({ view, title, subtitle, actions, central, local, leadGoal, proposalGoal, winGoal }) => {
    const { t } = useTranslation();

    return (
        <Box className={"info-header info-header-wizard info-header-" + view}>
            <Box className={"info-wrapper"}>

                <Tag size="small" color="secondary">{t('WIZARD')}</Tag>
                <span className="title">{title}</span>
                <span className="subtitle">{subtitle}</span>
                {actions}


            </Box>
            <Box className={"kpi-wrapper"}>
                <KPILocal title="Budget Centrale" translate={false} score={central} format={"currency"} className="chic" style={{minWidth:'260px'}}/>
                <KPILocal title="Budget Locale" translate={false} score={local} format={"currency"} className="chic" style={{minWidth:'260px'}}/>
                <KPILocal title="Obiettivo Lead" translate={false} score={leadGoal} />
                <KPILocal title="Obiettivo Proposte" translate={false} score={proposalGoal} />
                <KPILocal title="Obiettivi Accettate" translate={false} score={winGoal} />
            </Box>
        </Box>
    )
}

export default InfoHeaderBudgetAndGoal;